import { render, staticRenderFns } from "./renewalWhitelist.vue?vue&type=template&id=63853b19&scoped=true"
import script from "./renewalWhitelist.vue?vue&type=script&lang=js"
export * from "./renewalWhitelist.vue?vue&type=script&lang=js"
import style0 from "./renewalWhitelist.vue?vue&type=style&index=0&id=63853b19&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63853b19",
  null
  
)

export default component.exports